module.exports = __webpack_public_path__ + "img/sec_3_box2.d86c4bbb.png";